module.exports = __webpack_public_path__ + "img/guides-bg.56a7bc1.webp";